import { useAppSelector } from 'hooks'
import { useMemo } from 'react'
import { getStatusSelector } from 'redux/store/slices/statusSlice'
import { getNotificationsSelector } from 'redux/store/slices/wsSlice'
import { FLOW_STEPS } from 'share/types'
import { getWsStepStatus } from 'utils'

const useImprovePledgeFlowStatus = () => {
  const { APPROVE_PROPERTY_PLEDGES } = useAppSelector(getNotificationsSelector)
  const { current_step } = useAppSelector(getStatusSelector)

  const isApprovePropertyPledgesStepInProgressByWS = useMemo(
    () => getWsStepStatus(APPROVE_PROPERTY_PLEDGES) === 'IN_PROGRESS',
    [APPROVE_PROPERTY_PLEDGES]
  )

  const isApprovePropertyPledgesStepInProgressByStatus = useMemo(() => {
    if (!current_step) return false
    const { step, status } = current_step
    if (step === FLOW_STEPS.APPROVE_PROPERTY_PLEDGES && status === 'IN_PROGRESS') return true
    return false
  }, [current_step])

  return {
    isApprovePropertyPledgesStepInProgress:
      isApprovePropertyPledgesStepInProgressByStatus || isApprovePropertyPledgesStepInProgressByWS
  }
}

export { useImprovePledgeFlowStatus }
